import React, { useEffect, useState, useRef } from "react";
import { Card, CardBody, CardHeader } from "./../../components/card/card.jsx";
import { issueTracking, issueTrackingType } from "../../api/index.js";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/AuthContext.jsx";
import { downloadExcel } from "../../utils/exporter";
import {
  dateToToday,
  formatDateOnly,
  generateLocationToArray,
  getRequestStatusColor,
  getStatusColor,
  printLocation,
} from "../../utils/helper.jsx";
import { useDashboardContext } from "../../contexts/NewDashboardContext.jsx";
import { useNavigate, useRoutes } from "react-router-dom";
import ConfirmationDlg from "../../components/ConfirmationDlg/index.jsx";
import DataTable from "react-data-table-component";
import { LocationFilter } from "../../components/LocationFilter/index.jsx";
import { PermissionChecker } from "../../components/PermissionChecker/index.jsx";
import { SorterForm } from "../../components/Sorter/index.jsx";
import DebounceInput from "../../components/form/HorizontalDebounceInput/index.jsx";


function IssueTrackingList() {
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState({ page: 1, take: 10, totalData: 1, keyword: "" });
  const { config } = useAuth();
  const [deleteRow, setDeleteRow] = useState(null);
  const navigate = useNavigate();
  const [issueTypes, setIssueTypes] = useState([]);


  async function getData() {
    try {
   
      setLoading(true);
      const queryParam = {
        ...query,
      };

    

      const res = await issueTracking.list(queryParam);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data.results) {
          data.results.forEach((d) => {
            const locationNameArr = [];
            generateLocationToArray(d.location, locationNameArr);
            d.location_arr = locationNameArr.reverse();
          });

          setDatas(data.results);
        }
        if (data.totalData) {
          setQuery((prev) => ({
            ...prev,
            totalData: data.totalData,
          }));
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  }


  const getIssueType = async () => {
    const res = await issueTrackingType.list();
    if (res.ok) {
      const body = await res.json();
      setIssueTypes(body.data);
    }
  };



  async function deleteData() {
    try {
      const response = await issueTracking.delete(deleteRow.id);
      if (response.ok) {
        const body = await response.json();
        if (body.success) {
          toast.success(
            `This issue tracking has been deleted`
          );

          setDeleteRow(null);
          await getData();
        } else {
          toast.error(body.message);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }


  function showConfirmationDlg(row) {
    setDeleteRow(row);
  }
 

  function hideConfirmationDialog() {
    setDeleteRow(null);
  }


  
  function generateLocationWording() {
    let result = [];
    if (config && config?.location_wording) {
      const words = config?.location_wording.split(",");
      words.forEach((ln, index) => {
        result.push(ln);
      });
    }

    return result;
  }

  let columns = [
    {
      name: "Title",
      selector: (row) => row.title,
      minWidth: "150px",
    },
    ...generateLocationWording().map((w, i) => ({
      name: w,
      selector: (row) => printLocation(row.location_arr[i]),
    })),
    {
      name: "Asset",
      selector: (row) => row.asset?.asset_name,
    },
    {
      name: "Issue Type",
      selector: (row) => row.type?.name,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      cell: (row) => (
        <span
          className={`badge border border-${getStatusColor(
            row.status
          )} text-${getStatusColor(row.status)}`}
        >
          {row.status}
        </span>
      ),
    },
    {
      name: "Submitted At",
      selector: (row) => row.created_at,
      cell: (row) => formatDateOnly(row.created_at),
    },
    {
      name:"Action",
      selector: (row) => row.id,
      cell: (row) => {
        return (
          <div>
            <PermissionChecker permissions={["edit issue tracking"]} hideIfNotAllowed>
              <button
                onClick={() => {
                  navigate(`/issue-tracking/edit/${row.id}`);
                }}
                className="btn btn-sm btn-outline-warning mx-1"
              >
                <i className="fa fa-edit"></i>
              </button>
            </PermissionChecker>
            <PermissionChecker permissions={["delete issue tracking"]} hideIfNotAllowed>
              <button
                onClick={() => {
                  showConfirmationDlg(row);
                }}
                className="btn btn-sm btn-outline-danger"
              >
                <i className="fa fa-trash"></i>
              </button>
            </PermissionChecker>
          </div>
        );
      },
    }
  ];


  const handleChangeLocationFilter = (location_id) => {
    setQuery((prev) => ({
      ...prev,
      page: 1,
      location_id: location_id ? location_id : "",
    }));
  };

  const handleChangeSorter = (sorter) => {
    setQuery((prev) => ({
      ...prev,
      page: 1,
      orderBy: sorter ? sorter : "",
    }));
  };

  const handleChangeKeyword = (e) => {
    setQuery((prev) => ({
      ...prev,
      page: 1,
      keyword: e.target.value,
    }));
  };

  const handleChangeIssueType = (id) => {
    setQuery((prev) => ({
      ...prev,
      page: 1,
      type_id: id,
    }));
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, [query.page, query.take, query.location_id, query.type_id,query.orderBy,query.keyword]);
  

  useEffect(() => {
    getIssueType();
   
  }, []);




  return (
    <div >
  
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">ISSUE TRACKING</a>
            </li>
            <li className="breadcrumb-item active"> LIST</li>
          </ul>

          <h1 className="page-header">
            Issue Tracking List
          </h1>

          <hr className="mb-4" />

          <div id="datatable" className="mb-5">
            <div className="row mb-2 justify-content-sm-end">
          
            <div className="col-sm-3 mb-2 mb-sm-0">
                <DebounceInput name="keyword" placeholder={'Search issue'} showDebounceIndicator delay={1000} onchange={handleChangeKeyword} />
              </div>

              <div className="col-sm-2 mb-2 mb-sm-0">
                <LocationFilter onChange={handleChangeLocationFilter} withSublocations />
              </div>

              <div className="col-sm-2 mb-2 mb-sm-0">
                <SorterForm onChange={handleChangeSorter} fields={['created_at']} />
              </div> 

              <div className="col-sm-2 mb-2 mb-sm-0">
                <select
                  className="form-select btn btn-outline-theme"
                  defaultValue=""
                  onChange={(e) => {
                    handleChangeIssueType(e.target.value);
                  }}
                >
                  <option value="">
                    - Issue Type -
                  </option>
                  {issueTypes.map((c, i) => (
                    <option value={c.id}>{c.name}</option>
                  ))}
                </select>
              </div>
              <div className="col-sm-2 mb-2 mb-sm-0">
                <div class="row">
                  <div class={"col-sm-12"}>
                    <PermissionChecker permissions={["create issue tracking"]} hideIfNotAllowed> 
                    <button
                      onClick={() => {
                       
                      
                           navigate("/issue-tracking/add");
                      }}
                      className="btn btn-outline-theme w-100"
                    >
                      <i className="bi bi-plus"></i>
                      Add Issue{" "}
                    </button>
                    </PermissionChecker>
                  </div>
               
                </div>
              </div>
            </div>

      
              <div className="row">
                <div className="col-md-12">
                  <Card>
                    <CardBody>
                      <DataTable
                        progressPending={loading}
                        pointerOnHover
                        highlightOnHover
                   
                        onRowClicked={(row) => {
                          navigate(`/issue-tracking/detail/${row.id}`);
                        }}
                    
                        theme="dark"
                        columns={columns}
                        data={datas}
                        pagination
                        paginationServer
                        onChangeRowsPerPage={(row) =>
                          setQuery((prev) => ({ ...prev, page: 1, take: row }))
                        }
                        paginationTotalRows={query.totalData}
                        onChangePage={(page) =>
                          setQuery((prev) => ({ ...prev, page: page }))
                        }
                      />
                    </CardBody>
                  </Card>
                </div>
              </div>
         

        
          </div>
        </div>
      </div>

      {deleteRow && (
        <ConfirmationDlg
          title={"Delete Issue Tracking"}
          open={!!deleteRow}
          onClose={hideConfirmationDialog}
          onSubmit={deleteData}
        >
          <p style={{ pb: 2 }}>
            Are you sure you want to delete this issue tracking{" "}
            <strong>{deleteRow.title}</strong> ?
          </p>
        </ConfirmationDlg>
      )}
    </div>
  );
}

export default IssueTrackingList;
